import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

export const policyTemplateDirectoryRoleRequirementsApi = createApi({
  reducerPath: 'policyTemplateDirectoryRoleRequirements',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getDirectoryRoleRequirementsPreview: builder.query({
      query: ({ templateId, customerId }) => ({
        url: `/secure/policy/template/${templateId}/directory-role-requirements/preview`,
        params: { customerId },
      }),
    }),
  }),
})

export const { useGetDirectoryRoleRequirementsPreviewQuery } = policyTemplateDirectoryRoleRequirementsApi

export const useDirectoryRoleRequirementsPreview = ({ templateId, customerId: customerIdOverride }, options = {}) => {
  const selectedCustomerId = useSelector(getSelectedCustomerId)
  const customerId = customerIdOverride ?? selectedCustomerId

  return useGetDirectoryRoleRequirementsPreviewQuery(
    { templateId, customerId },
    { ...options, skip: options.skip || !templateId || !customerId },
  )
}
